import type { ReactNode } from 'react';

import { StaggerItem } from '@/shared/ui/animations';

interface SplitHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export const SplitHeader = ({ title, subtitle, actions }: SplitHeaderProps) => (
  <header className="flex items-center justify-between gap-4 px-6 pt-8 pb-10">
    <StaggerItem index={0}>
      <div className="flex flex-col gap-1">
        <h1 className="type-display-md text-foreground">{title}</h1>
        {subtitle && <p className="type-body-lg text-foreground-subtle">{subtitle}</p>}
      </div>
    </StaggerItem>
    {actions && (
      <StaggerItem index={1}>
        <div className="flex items-center gap-2">{actions}</div>
      </StaggerItem>
    )}
  </header>
);
